var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / KE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,14 C4.66666667,14 6.66666667,11.3834215 6.66666667,7.33333333 C6.66666667,3.28324517 4.66666667,0.666666667 3.33333333,0.666666667 C2,0.666666667 0,3.28324517 0,7.33333333 C0,11.3834215 2,14 3.33333333,14 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,9.33333333 C3.70152317,9.33333333 4,10.5272407 4,12 C4,13.4727593 3.70152317,14.6666667 3.33333333,14.6666667 C2.9651435,14.6666667 2.66666667,13.4727593 2.66666667,12 C2.66666667,10.5272407 2.9651435,9.33333333 3.33333333,9.33333333 Z M3.33333333,5.33333333 C3.70152317,5.33333333 4,6.22876383 4,7.33333333 C4,8.43790283 3.70152317,9.33333333 3.33333333,9.33333333 C2.9651435,9.33333333 2.66666667,8.43790283 2.66666667,7.33333333 C2.66666667,6.22876383 2.9651435,5.33333333 3.33333333,5.33333333 Z M3.33333333,0 C3.70152317,0 4,1.19390733 4,2.66666667 C4,4.139426 3.70152317,5.33333333 3.33333333,5.33333333 C2.9651435,5.33333333 2.66666667,4.139426 2.66666667,2.66666667 C2.66666667,1.19390733 2.9651435,0 3.33333333,0 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.5%",
    y: "-3.4%",
    width: "175.0%",
    height: "113.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-KE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#018301",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    x: 0,
    y: 5.33333333,
    width: 28,
    height: 9.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fill: "#DC0808",
    mask: "url(#mask-2)",
    x: 0,
    y: 6.66666667,
    width: 28,
    height: 6.66666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-225",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.666667, 2.666667)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    stroke: "none",
    fill: "#BC0000",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask-Copy",
    stroke: "none",
    fill: "#262626",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    cx: -2,
    cy: 7.33333333,
    rx: 3.33333333,
    ry: 7.33333333
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Mask-Copy-2",
    stroke: "none",
    fill: "#262626",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    cx: 8.66666667,
    cy: 7.33333333,
    rx: 3.33333333,
    ry: 7.33333333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Oval-228",
    stroke: "none",
    fill: "none",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-5)",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKe);
export default __webpack_public_path__ + "static/media/KE.df8bf131d68b815454b292b50b3496fe.svg";
export { ForwardRef as ReactComponent };